<template>
    <Card :loading="parentComponent.loading" overlay :header="$t('productList')">

        <DataTable v-if="parentComponent.item" :items="items" :fields="fields">
            <template #cell(action)="{item}">
                <div class="d-flex gap-2 justify-content-end">
                    <ButtonIcon size="sm" icon="trash-2" variant="danger" :loading="isDeleting(item.id)" @click="deleteItem(item)" />
                </div>
            </template>
            <template #afterTable>
                <ButtonIcon icon="plus" class="mt-4" @click="showModal()">{{ $t('addProducts') }}</ButtonIcon>
            </template>
        </DataTable>

        <ModalAddProducts />

    </Card>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import ModalAddProducts from './ModalAddProducts.vue';

    export default {
        name: 'Products',
        components: {
            DataTable,
            ModalAddProducts,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('producerProductGroups/groupProducts'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'sku', label: this.$t('sku') },
                    { key: 'ean', label: this.$t('ean') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            items() {
                return this.parentComponent.item.products || [];
            },
        },
        methods: {
            isDeleting(id) {
                return this.request.getLoading(`delete-${id}`);
            },
            deleteItem(item) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('confirmYouWantDelete'), {
                        title: this.$t('confirm'),
                        okTitle: this.$t('yes'),
                        cancelTitle: this.$t('cancel'),
                        okVariant: 'danger',
                    })
                    .then(value => {
                        if (value) {
                            this.request
                                .id(`delete-${item.id}`)
                                .delete({ urlParams: { groupId: this.parentComponent.id, id: item.id } })
                                .then(() => {
                                    this.removeItem(item);
                                })
                                .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                        }
                    });
            },
            removeItem(item) {
                const index = this.items.findIndex(el => el.id === item.id);
                if (index) this.items.splice(index, 1);
            },
            showModal() {
                this.$root.$emit('bv::show::modal', 'modal-add-products');
            },
        },
    };
</script>
